import { useForm } from "react-hook-form";
import { IFilterFleet } from "../../types/interface";
import Card from "../Reusable/Card";
import ComboboxFilter from "../Reusable/ComboboxFilter";
import DateRangePicker from "../Reusable/DateRangeField";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

export default function Filter() {
  const { control, setValue, getValues, watch } = useForm<IFilterFleet>({});

  return (
    <div>
      <Card title="Filter">
        <div className={tw`grid grid-cols-2 gap-2`}>
          <ComboboxFilter
            label="Status"
            queryKey="status"
            control={control}
            name="status"
            params={{
              is_active: true,
            }}
            url={""}
          />
          <DateRangePicker<IFilterFleet>
            setValue={setValue}
            getValues={getValues}
            name="created_range"
            label="Select Date Range"
            watch={watch}
          />
        </div>
      </Card>
    </div>
  );
}
